import { render, staticRenderFns } from "./Detail-ServiceFormTemplate.vue?vue&type=template&id=74e1def1"
import script from "./Detail-ServiceFormTemplate.vue?vue&type=script&lang=js"
export * from "./Detail-ServiceFormTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports